import { useFeatureAccess } from "../../access-control/hooks/useFeatureAccess";
import { FEATURE_KEYS } from "../../access-control/models/role-feature.models";
import AdminUwhcProvidersPanel from "../components/uwhc/AdminUwhcProvidersPanel";
import { ADMIN_PATHS } from "../models/admin.models";
import { Navigate } from "react-router-dom";

const AdminUwhcPage = () => {
  const { hasFeature } = useFeatureAccess();

  if (hasFeature(FEATURE_KEYS.ADMIN_REF_PARAMETERS_UWHC_VENDORS)) {
    return <AdminUwhcProvidersPanel />;
  }

  return <Navigate to={ADMIN_PATHS.root} replace />;
};

export default AdminUwhcPage;
